import { UiVaults } from 'src/constants/vaults';
import { UiVaultConfig } from 'src/@types/vaults';

// Memoized config cache to avoid repeated lookups
const vaultConfigCache = new Map<string, UiVaultConfig | undefined>();

/**
 * Cached version of UiVaults.getVaultConfig to avoid repeated lookups
 * This is particularly important for functions that iterate over many vaults
 * or are called frequently during renders.
 */
export const getVaultConfigCached = (
	vaultPubkey: string
): UiVaultConfig | undefined => {
	if (!vaultConfigCache.has(vaultPubkey)) {
		vaultConfigCache.set(vaultPubkey, UiVaults.getVaultConfig(vaultPubkey));
	}
	return vaultConfigCache.get(vaultPubkey);
};
